module.exports = __webpack_public_path__ + "static/media/Active_Low_Frequency_Towed_Sonar_01.639e3fbe.jpg";